import { ControlledDateTimePicker } from '@components/Form';

import type { PhasedRolloutFormValues } from './PhasedRolloutFormDialog';

export const PhasedRolloutControlledDateTimePicker =
  ControlledDateTimePicker as ControlledDateTimePicker<PhasedRolloutFormValues>;
